import { useLocation } from 'react-router-dom';
import RewardsTabs from './Components/RewardTab';
import { REWARD_TABS } from './utils';
const MyNetwork = ({ networkList }) => {
  const location = useLocation();
  const network_id = location.state?.network_id
  const beneficiary_esi_id = location.state?.beneficiary_esi_id
  const selectedDate = location.state?.selectedDate
  
  return (
    <RewardsTabs
      selectedStartDate={selectedDate}
      allowedTabs={[REWARD_TABS['NETWORK_INFLUENCER'], REWARD_TABS['NETWORK']]}
      networkList={networkList}
      network_id={network_id}
      beneficiary_esi_id={beneficiary_esi_id}
    />
  );
};
export default MyNetwork;
